import React from 'react';

import LoaderGif from 'assets/images/91.gif';
import LoaderGifBlueWhite from 'assets/images/rolling.gif';

function Loader(props) {
	let {
		type = 'white',
		className = ''
	} = props;
	return (
		<div className={'Loader ' + className} role="status">
			{type === 'white' && (<img src={LoaderGif} alt="loader" />)}
			{type === 'blue' && (<img src={LoaderGifBlueWhite} alt="loader" />)}
		</div>
	);
}

export default Loader;
